{
  "AddCRMTitle": "Add CRM Integration",
  "ModififyCRMTitle": "Modify CRM Integration",
  "CRMDetailsTitle": "Details",
  "CRMScopeTitle": "Scope",
  "CRMConfigurationTitle": "Configuration",
  "CRMGeneralIDLabel": "ID",
  "CRMDetailsIDLabelPlaceholder": "[Auto Assigned]",
  "CRMDetailsDescriptionLabel": "Description",
  "CRMValidationDescriptionLabel": "Description is required",
  "CRMConfigurationCRMTypeLabel": "CRM",
  "CRMConfigurationTypeNone": "None",
  "CRMConfigurationTab_Setting_Name": "Setting Name",
  "CRMConfigurationTab_Value": "Value",
  "NAME": "CRMModal"
}